export const NON_TOGGLABLE = 'non-togglable';
